import { AuthService } from 'src/app/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { SignupLoginService } from './../../services/signupLogin.service';
import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/store/app.state';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-api-key',
  templateUrl: './api-key.component.html',
  styleUrls: ['./api-key.component.css']
})
export class ApiKeyComponent implements OnInit {
  apiKey;
  loading = false;
  constructor(
    private authSrv: AuthService,
    private signupSrv: SignupLoginService,
    private toastr: ToastrService,
    store: Store<AppState>,
    private gs: GeneralService) {
      store.select("userInfo").subscribe(res => this.apiKey = res.apiKey);
  }

  ngOnInit() {}

  createApiKey() {
    this.loading = true;
    this.signupSrv.createApiKey().subscribe((res) => {
      const apiKey = res.payload.key;
      this.authSrv.updateUserAndOrg({apiKey})
      this.toastr.success('Api key generated successfully')
    }, err => {
      this.toastr.error('Error: Apikey error')
    }).add(() => this.loading = false)
  }

}
